import { captureException } from '@sentry/nextjs';
import { useRouter } from 'next/router';
import { CaptureEvent } from '../interfaces';
import { analytics } from '../services/analytics';
import { trpc } from '@/utils/trpc';

const useEvent = () => {
  const { query } = useRouter();
  const captureEventMutation = trpc.users.captureEvent.useMutation();

  const capture = async (event: CaptureEvent, saveEvent = true) => {
    try {
      if (query.searchTerm && query.searchTerm !== '') {
        event.properties = [
          ...(event.properties || []),
          {
            key: 'search_term',
            value: (query.searchTerm as string).toLowerCase(),
          },
        ];
      }

      // track in segment
      analytics.track(event.event, event);

      if (!saveEvent) return;
      // Send the event to the event store
      await captureEventMutation.mutateAsync({
        event: event.event,
        photo_id: event.photo_id,
        pack_id: event.pack_id,
        clip_id: event.clip_id,
        link_id: event.link_id,
        collection_uuid: event.collection_uuid,
        properties: event.properties?.map((property) => ({
          key: property.key,
          value: property.value,
        })),
      });
    } catch (error) {
      captureException(error);
    }
  };

  return {
    capture,
  };
};

export default useEvent;
